import styles from './styles.less';
import Split from '../split';
import Content from '../content';
import React from 'react';

class Comics extends React.Component {

    constructor(props) {
        super(props);
    }

    componentWillMount() {

    }

    render() {
        const data = this.props.data;

        return (
            <div className={ this.props.className }>
                { data.map((section, i) => {
                    if (section.type === 'split') {
                        return (
                            <div
                                key={ i }
                                className={ styles.splitWrapper }
                            >
                                <Split
                                    className={ styles.split }
                                    data={ section }
                                />
                            </div>
                        );
                    }

                    else if (section.type === 'full') {
                        return (
                            <div
                                key={ i }
                                className={ styles.full }
                            >
                                <Content data={ section } />
                            </div>
                        );
                    }

                    else return null;

                }) }
            </div>
        );
    }
}


export default Comics;



// WEBPACK FOOTER //
// ./src/client/components/comics/index.js